module.exports = __webpack_public_path__ + "static/img/img_logo_scan.0b9a4a4d.png";